<div
  *ngIf="player === 'lottie'"
  id="player-lottie"
>
  <kwikui-animation-player-lottie
    [config]="config"
  ></kwikui-animation-player-lottie>
</div>
